import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { createApMapData, deleteApMapData, listApMaps, updateApMapData } from '../Api/ApMap/ApMapApi';
import { addError, clearError } from './Error';

export interface ApMap {
  id?: string;
  ap_id: string;
  ap_name: string;
  ap_sfid?: string;
  ap_rpm: string;
  ap_rpm_rep_id?: string;
  ap_rpm_rep_name?: string;
  ap_rpm_rep_agency_name?: string;
}

const tallyApMapsSubject = new BehaviorSubject<ApMap[]>([] as ApMap[]);
const tallyApMapsLoadingSubject = new BehaviorSubject<boolean>(false);

export const getTallyApMapsSubject = (): BehaviorSubject<ApMap[]> => tallyApMapsSubject;
export const getTallyApMapsLoadingSubject = (): BehaviorSubject<boolean> => tallyApMapsLoadingSubject;

export const fetchApMaps = async () => {
  tallyApMapsLoadingSubject.next(true);

  const { data, error } = await listApMaps();

  if (data?.apMaps) {
    clearError('ap-map');
    tallyApMapsSubject.next(data.apMaps);
  }
  if (error) addError('ap-map', error.message);

  tallyApMapsLoadingSubject.next(false);
};

export const createApMap = async (apMap: Partial<ApMap>) => {
  const apMapData: ApMap = { ...({} as ApMap), ...apMap };

  const { data, error } = await createApMapData(apMapData);

  if (data) {
    clearError('ap-map');
    fetchApMaps();
  }
  if (error) addError('ap-map', error.message);

  return { data, error };
};

export const updateApMap = async (update: ApMap) => {
  const { data, error } = await updateApMapData(update);
  if (data) {
    clearError('ap-map');
    fetchApMaps();
  }
  if (error) addError('ap-map', error.message);

  return { data, error };
};

export const deleteApMap = async (id: string) => {
  const { data, error } = await deleteApMapData(id);

  if (data) {
    clearError('ap-map');
    fetchApMaps();
  }
  if (error) addError('ap-map', error.message);
};
